import { render, staticRenderFns } from "./ModalAvailableForRedemption.vue?vue&type=template&id=6050fced&scoped=true"
import script from "./ModalAvailableForRedemption.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalAvailableForRedemption.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalAvailableForRedemption.vue?vue&type=style&index=0&id=6050fced&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050fced",
  null
  
)

export default component.exports